export default "__VITE_ASSET__DGKCJIup__"